import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

const url = 'active-offers/dashboard/discard-reasons'

export default defineStore(
  'active-offers-discard-reasons',
  storeModule.createStoreModule('active-offers-discard-reasons', {
    fetchListURL: url,
    fetchFiltersURL: `${url}/filters`
  })
)
